
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounttype",
      function () {
        return require("private-next-pages/accounttype.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounttype"])
      });
    }
  